import React from 'react';
import Navbar from './Navbar';
import HomeVideo from './Homevideo';
import '../css/Home.css'
import Aboutushome from '../subcomponent/Aboutushome';
import Programhome from '../subcomponent/Programhome';
import Client from '../subcomponent/Client';

import CareerPage from '../subcomponent/CarrerHome';
import ContactusHome from '../subcomponent/ContactusHome';

const Home = () => {
  return (
    <div className="component-class">
     
      <div className="video-and-content">
        
        <HomeVideo className="home-video" />
        <br></br>
     
      <Programhome></Programhome>
      <br>
      </br>
       <Aboutushome></Aboutushome>
      <br></br>
      <Client></Client>
      <br></br>
      <CareerPage></CareerPage>
      <br>
      </br>
      <ContactusHome></ContactusHome>
      <br></br>
      </div>
    </div>
  );
};

export default Home;
